import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import {
  makeStyles,
  Skeleton,
  SkeletonItem,
  useId,
} from '@fluentui/react-components';

const useStyles = makeStyles({
  row: {
    alignItems: 'center',
    columnGap: '10px',
    display: 'grid',
    gridTemplateColumns: 'min-content 80%',
    paddingBottom: '10px',
    position: 'relative',
    rowGap: '10px',
  },
});

export const CardContentSkeleton = ({ rowCount }) => {
  const skeletonId = useId('cardContentSkeleton');
  const rowKeys = useMemo(() => [...Array(rowCount).keys()], [rowCount]);
  const styles = useStyles();

  return (
    <div>
      <Skeleton>
        {rowKeys.map(rowKey => (
          <div className={styles.row} key={`${skeletonId}-${rowKey}`}>
            <SkeletonItem shape="circle" size={24} />
            <SkeletonItem size={16} />
          </div>
        ))}
      </Skeleton>
    </div>
  );
};

CardContentSkeleton.propTypes = {
  rowCount: PropTypes.number,
};

CardContentSkeleton.defaultProps = {
  rowCount: 3,
};
